import React, { Component } from 'react'
import { checkTranslation, phoneStandardView, priceStandardView, translate } from '../utils/useful';
// import TabHeader from '../components/notifComp/TabHeader';
import HttpServices from '../utils/Http.services';
import * as actions from '../stores/actionsList';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { addTopic, removeTopic } from '../utils/socket.services';
import Pagination from '../components/Pagination';
import Loader from 'react-loader-spinner'
import moment from 'jalali-moment';
import FilterModal from '../modals/FilterModal';
import TLink from '../components/TLink';
import PieChart from '../components/PieChart';
import store from '../stores/storeConfig';


class Broadcasts extends Component {

    state = {
        inbox: [],
        active: 0,
        limit: 20,
        currentPage: 0,
        opened: null,
        filter: {},
        headers: [
            { type: 'SelectInput', key: 'document', col: '6', information: { label: '{{lang}}document', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getAllDocument', filter: {} }, settings: { required: true }, showMain: true },

            // { type: 'TextInput', key: 'title', col: '6', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },
            // { key: 'thing', type: 'SelectInput', col: '6', information: { label: '{{lang}}Thing', address: 'getMyThings', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Thing', required: true }, showMain: true },
            // { key: 'applet', type: 'SelectInput', col: '6', information: { label: '{{lang}}Applet', address: 'getMyApplets', filter: {}, fields: { title: 'aTarget.name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Applet', required: true }, showMain: true },
            // { type: 'SelectInput', key: 'refType', information: { label: '{{lang}}useful.type', type: 'local', items: [{ value: 'applet', title: 'Applet' }, { value: 'thing', title: 'Thing' }, { value: 'dashboard', title: 'Dashboard' }], placeholder: '{{lang}}placeholders.insertType', required: true } },

            // { type: 'DateInput', key: 'cDate', hideComponent: true, information: { label: '{{lang}}Create date', placeholder: '{{lang}}Create date', required: false, hideComponent: true } },

            // { key: 'body', type: 'EditorInput', col: '12', information: { label: '{{lang}}Body', placeholder: '{{lang}}body', required: true, inputClass: 'null' }, showMain: false },
            // { key: 'attachments', type: 'FileInput', col: '12', information: { label: '{{lang}}Attachments', placeholder: '{{lang}}Attachments', required: false, inputClass: 'null' }, showMain: false },

        ],

        Tab: [

            { name: "{{lang}}All", number: "0" },
            { name: "{{lang}}Unseen", number: "0" },

        ]
    }

    componentDidMount() {
        this.fetchInbox(true)
    }

    fetchInbox(getCount) {

        if (this.props.user?.loggedin) {

            this.setState({ isLoadingInbox: true, inbox: [] })

            let body = { filter: {} }


            body.filter = { ...this.state.filter } ?? {}

            for (const [key, value] of Object.entries(body)) {
                if (/\{\{(.*?)\}\}/.test(value)) {

                    if (this.props.variables) {
                        body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    }
                }
            }

            if (this.state.opened != null) {
                body.filter.opened = this.state.opened
            }

            body.limit = this.state.limit
            body.skip = this.state.currentPage
            body.getCount = getCount
            console.log('getMyInboxoo')
            HttpServices.request('getMyInbox', body, (fetchResult, fetchError, fetchStatus) => {
                console.log('getMyInboxoo',fetchResult)
                this.setState({ isLoadingInbox: false })
                if (fetchError) {
                    // this.setState({ pageStatus: fetchStatus })
                    this.props.actions.addNotif({ type: 'error', title: checkTranslation('{{lang}}errors.loadDataFailed'), description: checkTranslation(fetchError.message) })
                    return
                }
                let inboxes={list:fetchResult?.info,count:fetchResult?.info?.length}
                store.dispatch(actions.addInbox(inboxes))
                this.setState({ inbox: fetchResult.info, }, () => {
                    // this.calcNoficCount()

                })

                if (fetchResult.count) {
                    this.setState({ totalCount: fetchResult.count })
                }

                addTopic(this.state.inboxId, this.props.user?.info?._id, 'users', null, this.updateInbox)

            })
        }
    }




    seenAll = () => {

        HttpServices.request('seenAllBroadcasts', {}, (fetchResult, fetchError, fetchStatus) => {

            if (fetchError) {
                return
            }


            let inbox = this.state.inbox
            inbox.forEach((element, index) => {
                element.opened = true
            });


            this.setState({ inbox }, () => {
                // this.calcNoficCount()
            })


            this.props.actions.addNotif({ type: 'success', title: checkTranslation('{{lang}}info.seenAll'), description: checkTranslation('{{lang}}info.seenAllSuccessfully') })
            this.props.actions.broadcastSeenAll()


        })

    }




    notifSeen = (id) => {

        HttpServices.request('seenBroadcast', { id }, (fetchResult, fetchError, fetchStatus) => {
            // console.log(fetchResult)
            if (fetchError) {
                return
            }

            let inbox = this.state.inbox
            inbox.forEach(element => {
                if (element._id == id) {
                    element.opened = true
                }
            });

            this.props.actions.broadcastSeen(id)


            this.setState({ inbox }, () => {
                // this.calcNoficCount()
            })


        })

    }



    changeTab = (e, index) => {

        this.setState({ opened: index == 1 ? false : null }, () => {
            this.fetchInbox(true)
            this.setState({ active: index, totalCount: null })

        })

    }


    changePage = (index) => {
        this.setState({ currentPage: index }, () => {
            this.fetchInbox()
        })
    }



    calcNoficCount = () => {
        let count = 0
        let inbox = this.state.inbox
        inbox.forEach(element => {
            if (!element.opened) {
                count++
            }
        });

        this.setState({ notifCount: count })
    }



    openFilterModal() {
        this.filterModal.showModal()
    }

    doFilter = (data) => {
        console.log(data)
        this.setState({ currentPage: 0, filter: data, totalCount: null }, () => {
            this.fetchInbox(true)
            this.filterModal.modal.hideModal()

        })
    }


    filterLabelCreator(rawprop) {
        let prop = JSON.parse(JSON.stringify(rawprop))
        // console.log(prop)
        let isArray = false
        if (Array.isArray(prop.value)) {
            isArray = true
        }

        // let label
        let value = prop.value
        if (prop.type == 'PhoneInput') {
            value = phoneStandardView(value)
        }


        if (prop.type == 'DateInput') {
            if (Array.isArray(value)) {
                value.forEach((element, index) => {
                    value[index] = moment(element).format('jYYYY/jMM/jDD')

                });
            } else {
                value = moment(value).format('jYYYY/jMM/jDD')

            }
        }


        if (prop.dictionary) {

            if (Array.isArray(value)) {
                for (let i = 0; i < value.length; i++) {
                    const element = value[i];
                    if (prop.dictionary[element]) {
                        value[i] = prop.dictionary[element]
                    }
                }
            } else {
                if (prop.dictionary[value]) {
                    value = prop.dictionary[value]
                }
            }
        }

        let label = checkTranslation(prop.label) + ' ' + prop.operator + ' ' + value


        return label
    }


    removeFilter = (prop) => {
        let filter = this.state.filter
        delete filter[prop.key]
        // console.log(filter)
        this.setState({ filter }, () => {
            this.fetchInbox(true)
        })
    }







    render() {
        return (
            <div className='w-100' style={{}}>
                <div className="notification-container">
                    <div className="container-sticky d-flex flex-column" style={{}}>

                        <div className="notif-container  ">
                            <div className="header-notification flexcb pb-2 w-100 pt-3">
                                <h3 className='text-semibig pb-0 px-3 m-0 '>{translate('Messages')}</h3>
                                {!this.props.page?.hideFilter && (
                                    <button onClick={() => this.openFilterModal()} className="flexcc p-0 mx-3" style={{ flex: 1, boxShadow: '0px 0px 15px #00000005', color: '#789', maxWidth: 'fit-content' }}>

                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="" style={{ width: 30 }}>
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                                        </svg>

                                    </button>
                                )}
                            </div>
                            {/* <div className='flexcb pb-2'>
                                <div className="tab-header-notification ">
                                    <div className="tab-header-link px-3 mt-2 d-flex">
                                        {this.state.Tab.map((prop, index) => {
                                            return (
                                                <button className={' text-normal '} style={{ borderBottom: this.state.active === index ? '2px solid #1a519c' : '2px solid transparent' }} onClick={(e) => this.changeTab(e, index)} >
                                                    <p className=''>{checkTranslation(prop.name)}</p>
                                                    {this.state.active === index && this.state.totalCount && (
                                                        <span style={{ display: prop.number ? "inline" : "none" }} className={'text-small white ' + (this.state.active === index ? "notification-number-active mld-2" : 'notification-number mld-2')}>{this.state.totalCount > 999 ? '+999' : this.state.totalCount}</span>
                                                    )}
                                                </button>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div> */}
                        </div>
                        {/* <hr className='head-sub-line m-0' /> */}
                    </div>


                    <div className="flexc px-2 pb-1">
                        {this.state.filter && Object.values(this.state.filter).map((prop, index) => {
                            if ((prop.key != 'location') && (prop.key != 'location1')) {
                                return (
                                    <div className="flexcc mrd-2 mb-1 mt-2" key={prop.key} style={{ backgroundColor: '#f2f6f8', borderRadius: 4, padding: '4px 10px' }}>
                                        <button onClick={() => this.removeFilter(prop, null)} className="p-0 m-0 flexcc">
                                            <img className="mrd-2 opacity-7" src="/images/close.svg" alt="" width="10px" />
                                        </button>
                                        <p className="text-smaller">{this.filterLabelCreator(prop)}</p>
                                    </div>
                                )
                            } else {
                                return (
                                    <div className="flexcc mrd-2 mb-1 mt-2" key={prop.key} style={{ backgroundColor: '#f2f6f8', borderRadius: 4, padding: '4px 10px' }}>
                                        <button onClick={() => this.removeFilter(prop, null)} className="p-0 m-0 flexcc">
                                            <img className="mrd-2 opacity-7" src="/images/close.svg" alt="" width="10px" />
                                        </button>
                                        <p className="text-smaller">LAT {prop.value.lat} - LNG {prop.value.lng} {prop.value.radius ? (" - Radius " + priceStandardView(prop.value.radius) + ' meters') : ""} </p>
                                    </div>
                                )
                            }
                        }
                        )}

                    </div>

                    <div className='px-3 px-md-0'>
                        <div className='row m-0 '>
                            {this.state.inbox?.reverse().map((prop, index) => {
                                console.log('propiis', prop)
                                return (
                                    <div className='col-12 col-sm-6 col-md-3 col-lg-2 cursor-pointer p-0 p-sm-2 mt-2 mt-md-4 ' onClick={() => this.notifSeen(prop._id)} >
                                        <TLink to={prop.url}>


                                            <div className="d-flex px-2 px-md-3 py-2 py-md-3 h-100 flex-column" style={{ justifyContent: 'center', opacity: prop.opened ? 0.5 : 1, backgroundColor: '#f2f2f2', borderRadius: 8 }}>
                                                <div className="d-flex mb-3" style={{ alignItems: 'flex-start' }}>
                                                    <img className='proflie-img invert' style={{ opacity: '0.7' }} width={20} src={'/images/icons/notif.svg'} alt="notif" />
                                                    <div className=" mld-3">
                                                        {prop?.title ? (

                                                            <p className='text-normal text-bold ' style={{ color: '#444' }}>{prop?.title}.</p>
                                                        ) : <></>}
                                                        {prop?.description ? (

                                                            <p className='' style={{ color: '#777', fontSize: '11px' }}>{prop?.description}.</p>
                                                        ) : <></>}
                                                    </div>
                                                </div>
                                                <p className='mld-3 text-small mt-1' style={{ color: '#777', fontSize: '11px' }}>{moment(prop.cDate).format('YYYY/MM/DD HH:mm')}</p>
                                            </div>

                                        </TLink>
                                    </div>
                                )
                            })}
                        </div>
                    </div>



                    {!this.state.isLoadingInbox && this.state.inbox.length == 0 && (
                        <div className="text-center p-2 my-5">
                            <p className="text-normal">{translate('No message found!')}</p>
                        </div>
                    )}

                    {this.state.isLoadingInbox && (
                        <div className="p-2 text-center my-5">
                            <Loader
                                type="Oval"
                                color="#184d94"
                                height="40"
                                width="40"
                            />
                        </div>
                    )}
                    {!this.state.isLoadingInbox && (
                        <div className="py-1" style={{ position: 'sticky', bottom: 0, backgroundColor: '#ffffffee' }}>
                            <Pagination hideInput={true} currentPage={this.state.currentPage} totalCount={this.state.totalCount} limit={this.state.limit} changePage={this.changePage} />
                        </div>
                    )}

                </div>


                <FilterModal
                    open={true}
                    ref={el => this.filterModal = el}
                    initData={this.state.filter}
                    page={this.props.page}
                    headers={this.state?.headers}
                    doFilter={this.doFilter} />

            </div>
        )
    }
}

// export default ;

const mapStateToProps = state => ({ settings: state.settings, cart: state.cart, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Broadcasts);
